import RootRoute from "./routes";
import "./App.css";
import { useEffect } from "react";
import { SSOAuthorization, ENV } from "more-sso-sdk";

// SSOAuthorization.init({
//   env: process.env.REACT_APP_ENV === "UAT" ? ENV.DEV : ENV.PROD,
//   redirectUrl: process.env.REACT_APP_ENV === "UAT" ? "https://id.dev.more.in/login" : "https://id.more.in/login",
//   app: process.env.REACT_APP_ENV === 'UAT' ? "jedi_uat" : "jedi",
//   idp: process.env.REACT_APP_ENV === 'UAT' ? "https://dev.api.more.in/sso" : "https://api.more.in/sso",
// });

SSOAuthorization.init({
  env: ENV.PROD,
  redirectUrl: "https://id.more.in/login",
  app: "jedi",
  idp: "https://id.api.more.in/sso",
});

function App() {

  useEffect(() => {
    console.log('NODE ENV : ', process.env.NODE_ENV);
    console.log('REACT ENV : ', process.env.REACT_APP_ENV);
  }, [])

  return (
    <div className="App">
      <RootRoute />
    </div>
  );
}

export default App;
